interface IErrorDisplayComponentProps {
  error: string
}
export default function ErrorDisplay(props: IErrorDisplayComponentProps) {
  return <div>{props.error}</div>
}
